import { gql } from '@apollo/client';
const REMOVE_ORDER = gql `
  mutation RemoveOrder($orderNodeId: ID!) {
    removeOrderDraft(orderNodeId: $orderNodeId) {
      removed
    }
  }
`;
export default REMOVE_ORDER;
